module.exports = __webpack_public_path__ + "img/abo4.912426b8.jpg";